var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M399.109 143.997L410.158 151.997C429.373 167.496 440.422 184.995 442.824 204.995C463.481 200.995 489.902 203.995 501.431 211.994L512 218.494L510.078 222.494C506.716 229.994 505.755 231.994 505.275 232.993C486.539 270.492 449.55 270.992 432.256 270.492C388.541 379.988 295.346 440.485 169.484 440.485C111.357 440.485 67.1618 421.986 37.3778 385.487C-2.01394 337.489 -2.01394 274.992 1.34877 254.993L2.30954 250.993H349.629C367.884 250.993 381.815 245.993 388.541 241.993C381.335 230.994 378.933 218.494 378.452 211.494C377.011 191.495 381.815 170.496 391.423 155.497L399.109 143.997ZM92.6223 190.995V240.993H39.7797V190.995H92.6223ZM155.073 190.995V240.993H102.23V190.995H155.073ZM217.523 190.995V240.993H164.68V190.995H217.523ZM279.973 190.995V240.993H227.131V190.995H279.973ZM342.423 190.995V240.993H289.581V190.995H342.423ZM279.973 130.998V180.996H227.131V130.998H279.973ZM217.523 130.998V180.996H164.68V130.998H217.523ZM155.073 130.998V180.996H102.23V130.998H155.073ZM279.973 71V120.998H227.131V71H279.973Z",
    fill: "#2396ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.0071acc860d3896bde35a0c64c0387e6.svg";
export { ForwardRef as ReactComponent };